export default __webpack_public_path__ + "static/media/FCEPL.7cc78ffe.png";